module.exports = __webpack_public_path__ + "fa-brands-400.svg?b60a5dffc2153ae0169c70b1d50479e7";